import React, { useState, useEffect, useRef } from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
//import { motion } from 'framer-motion'
import { Typography } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
//import Link from "@material-ui/core/Link";
//import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';


//function

const useStyles = makeStyles((theme) => ({
    animate_container:{
        position: 'relative',
        marginBottom: theme.spacing(5),
    },
    caution_text:{
        marginTop: theme.spacing(5),
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    title: {
        [theme.breakpoints.down('md')]:{
        },
        [theme.breakpoints.up('md')]:{
            fontSize: '35px',
            letterSpacing: '10px'
        },
        fontWeight: 'bold',
        whiteSpace: 'pre-line',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'white'
    },
    title_img:{
        width: '100%'
    },
    title_img_container:{
        position: 'relative',
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
    },
    text_box:{
        float: 'right'
    },
    sub_title:{
        fontWeight: 'bold',
        marginTop: theme.spacing(10),
        marginBottom: theme.spacing(5),
        borderStyle: 'solid',
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderRadius:10,
        borderWidth: 1,
    },
    line_url:{
        [theme.breakpoints.down('md')]:{
            margin: 'auto',
            marginBottom: theme.spacing(3)
        },
        [theme.breakpoints.up('md')]:{
            margin: 'auto',
            marginBottom: theme.spacing(3)
        },
        height: '150px',
        

    },
    line_url_container:{
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(10),
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
    },
    method_container:{
        marginTop: theme.spacing(12),
        position: 'static'
    },
    method_sub_title:{
        fontWeight: 'bold',
        marginBottom: theme.spacing(2)
    },
    movingText:{
        position: 'absolute',
        fontSize: '30px',
        overflow: 'hidden'
    },
    movingText2:{
        position: 'absolute',
        top: 25,
        overflow: 'hidden'
    },
    movingText3:{
        position: 'absolute',
        top: 40,
        fontSize: '25px',
        overflow: 'hidden'
    },
    movingText4:{
        position: 'absolute',
        top: 60,
        fontSize: '28px',
        overflow: 'hidden'
    },
    movingTextContainer:{
        
    },
    shooting_method:{
        [theme.breakpoints.down('md')]:{
            display: 'block',
            width: '100%',
            maxWidth: '360px',
            marginRight: 'auto',
            marginLeft: 'auto'
        },
        [theme.breakpoints.up('md')]:{
            height: '300px'
        },
        marginTop: theme.spacing(2),
        objectFit: 'cover'
    },
    text:{
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
        whiteSpace: 'pre-line'
    },
    guide_section:{
        maxWidth: '1080px',
        margin: '0 auto',
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2)
    },
    guide_lead:{
        maxWidth: '760px',
        margin: '0 auto',
        marginBottom: theme.spacing(3),
        lineHeight: 1.9,
        whiteSpace: 'pre-line'
    },
    checklist_card:{
        height: '100%',
        padding: theme.spacing(2.5),
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: 8,
        backgroundColor: '#fff'
    },
    checklist_title:{
        fontWeight: 'bold',
        marginBottom: theme.spacing(2)
    },
    checklist_item:{
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.25),
        marginBottom: theme.spacing(1.5),
        lineHeight: 1.7
    },
    checklist_number:{
        flex: '0 0 24px',
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: 'black',
        color: 'white',
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '24px',
        textAlign: 'center'
    },
    checklist_note:{
        color: 'rgba(0, 0, 0, 0.62)',
        fontSize: 13,
        lineHeight: 1.7
    },
    example_box:{
        marginTop: theme.spacing(4),
        padding: theme.spacing(2.5),
        borderRadius: 8,
        backgroundColor: theme.palette.primary['100'],
        border: '1px solid rgba(0, 0, 0, 0.08)'
    },
    example_text:{
        marginTop: theme.spacing(1),
        lineHeight: 1.9,
        whiteSpace: 'pre-line'
    },
    line_cta_button:{
        color: 'white',
        backgroundColor: '#06C755',
        '&:hover':{
            backgroundColor: '#05a849'
        }
    }
}))

//const frist_text = ["COMME des GARCONS COMME des GARCONS HOMME PLUS YOHJI YAMAMOTO ALEXANDER MCQUEEN BALECIAGA BOTTER CECILIEBAHNSE CELINE DAIRIKU DIOR DOUBLET DRIES VAN NOTEN "]

const photoChecklist = [
    {
        title: '表の全体写真',
        note: 'アイテム全体の形が分かるように撮影してください。'
    },
    {
        title: '裏の全体写真',
        note: '背面のデザインや状態が分かるように撮影してください。'
    },
    {
        title: 'ブランドタグ',
        note: 'ブランド名、ロゴ、タグの状態が読める写真をお送りください。'
    },
    {
        title: '品質タグ',
        note: '素材表記と製品番号が分かるように撮影してください。'
    },
    {
        title: '傷・汚れの箇所',
        note: '傷、汚れ、ほつれ、変色がある場合は該当箇所も撮影してください。'
    }
]

const textChecklist = [
    'ブランド',
    'アイテム名',
    '商品状態',
    'サイズ'
]

function LineEstimate(){
    const classes = useStyles()
    const textRef = useRef(null)
    const [textWidth, setTextWidth] = useState()
    const location = useLocation()

    const pageTitle = "LINE査定の送り方｜Enclopedia（アンクロペディア）ブランド服の高価買取"
    const pageDescription = "LINE査定で送る写真と必要事項を分かりやすくご案内。表裏の全体写真、ブランドタグ、品質タグ、状態やサイズを送るだけでブランド洋服を無料査定。"
    const ORIGIN = 'https://www.enclopedia-official.com'
    const canonicalUrl = `${ORIGIN}${location.pathname}`
    const absImage = (src) => (src && src.startsWith('http')) ? src : (src ? `${ORIGIN}${src.startsWith('/') ? src : '/' + src}` : '')
    const buildImg = (path) => {
        const base = (process.env.REACT_APP_IMAGE_URL || '').replace(/\/+$/,'')
        const cleanPath = path.replace(/^\/+/, '')
        return `${base}/${cleanPath}`
    }
    const heroImg = absImage(buildImg('subscription/line_estimate5.jpg'))

    console.log(textWidth)

    useEffect(() => {
        const calculateTextWidth = () => {
            if (textRef.current) {
              setTextWidth(textRef.current.offsetWidth);
            }
          };
      
          calculateTextWidth(); // 初回の計算
      
          window.addEventListener('resize', calculateTextWidth);
      
          // コンポーネントがアンマウントされるときにイベントリスナーをクリーンアップ
          return () => {
            window.removeEventListener('resize', calculateTextWidth);
          };
      }, []);

    // レンダリング後に静的なmetaも上書き（前回問題の対策）
    useEffect(() => {
        try{
            const metas = document.querySelectorAll('meta[name="description"]')
            metas.forEach((el) => el.setAttribute('content', pageDescription))
            const ogDesc = document.querySelectorAll('meta[property="og:description"]')
            ogDesc.forEach((el) => el.setAttribute('content', pageDescription))
            const ogTitle = document.querySelectorAll('meta[property="og:title"]')
            ogTitle.forEach((el) => el.setAttribute('content', pageTitle))
            const ogUrl = document.querySelectorAll('meta[property="og:url"]')
            ogUrl.forEach((el) => el.setAttribute('content', canonicalUrl))
            const ogImage = document.querySelectorAll('meta[property="og:image"]')
            ogImage.forEach((el) => el.setAttribute('content', heroImg))
        }catch(e){ /* no-op */ }
    }, [pageDescription, pageTitle, canonicalUrl, heroImg])

    return(
        <div className={classes.root}>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="canonical" href={canonicalUrl} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={heroImg} />
                <meta property="og:site_name" content="Enclopedia" />
                <meta name="twitter:card" content="summary_large_image" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            {"@type": "ListItem", "position": 1, "name": "ホーム", "item": ORIGIN },
                            {"@type": "ListItem", "position": 2, "name": "買取", "item": `${ORIGIN}/kaitori`},
                            {"@type": "ListItem", "position": 3, "name": "LINE査定", "item": canonicalUrl}
                        ]
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "HowTo",
                        "name": "LINE査定の流れ",
                        "step": [
                            {"@type": "HowToStep", "position": 1, "name": "友達追加", "text": "LINEでEnclopediaを友達に追加"},
                            {"@type": "HowToStep", "position": 2, "name": "撮影", "text": "表の全体写真、裏の全体写真、ブランドタグ、品質タグ、傷や汚れの箇所を撮影"},
                            {"@type": "HowToStep", "position": 3, "name": "送信", "text": "ブランド、アイテム名、商品状態、サイズを写真と一緒にLINEへ送信"},
                            {"@type": "HowToStep", "position": 4, "name": "査定結果", "text": "24時間以内に査定結果をご案内"}
                        ]
                    })}
                </script>
            </Helmet>
            <Container maxWidth={"xl"} style={{padding: 'initial', overflow: 'hidden'}}>
                <div className={classes.title_img_container}>
                    <Typography variant={"h1"} component="h1" className={classes.title} align="center">
                        {`ブランド買取はEnclopediaにお任せください`}
                    </Typography>
                    <img className={classes.title_img} style={{width: '100%'}} src={buildImg('subscription/line_estimate5.jpg')} alt="LINE査定のキービジュアル" />
                </div>
                {/*
                <div style={{marginBottom: '100px', position: 'static'}}>
                    <div className={classes.animate_container}>
                        <motion.div
                        className={classes.movingTextContainer}
                        initial={{x: `-2884px`}}
                        animate={{x: `100%`}}
                        transition={{duration:30, ease:'linear', repeat: Infinity}}
                        >
                            <Typography variant={"h2"} component="h2" className={classes.movingText} ref={textRef} noWrap style={{fontWeight:'bold'}}>
                                COMME des GARCONS COMME des GARCONS HOMME PLUS YOHJI YAMAMOTO ALEXANDER MCQUEEN BALECIAGA BOTTER CECILIEBAHNSE CELINE DAIRIKU DIOR DOUBLET DRIES VAN NOTEN
                            </Typography>
                        </motion.div>
                        <motion.div
                        className={classes.movingTextContainer}
                        initial={{x: '100%'}}
                        animate={{x:`-1923px`}}
                        transition={{duration:25, ease:'linear', repeat: Infinity}}
                        >
                            <Typography variant={"h2"} component="h2" className={classes.movingText2} align="center" noWrap style={{fontWeight:'bold'}}>
                                {frist_text[0]}
                            </Typography>
                        </motion.div>
                        <motion.div
                        className={classes.movingTextContainer}
                        initial={{x: `-2404px`}}
                        animate={{x: `100%`}}
                        transition={{duration:20, ease:'linear', repeat: Infinity}}
                        >
                            <Typography variant={"h2"} component="h2" className={classes.movingText3} noWrap style={{fontWeight:'bold'}}>
                                COMME des GARCONS COMME des GARCONS HOMME PLUS YOHJI YAMAMOTO ALEXANDER MCQUEEN BALECIAGA BOTTER CECILIEBAHNSE CELINE DAIRIKU DIOR DOUBLET DRIES VAN NOTEN
                            </Typography>
                        </motion.div>
                        <motion.div
                        className={classes.movingTextContainer}
                        initial={{x: '100%'}}
                        animate={{x:`-1923px`}}
                        transition={{duration:35, ease:'linear', repeat: Infinity}}
                        >
                            <Typography variant={"h2"} component="h2" className={classes.movingText4} align="center" noWrap style={{fontWeight:'bold'}}>
                                {frist_text[0]}
                            </Typography>
                        </motion.div>
                    </div>
                </div>
                */}
                <div className={classes.method_container}>
                    <div className={classes.guide_section}>
                        <Typography variant={"h1"} component="h2" className={classes.sub_title} align="center">
                            LINEで送るもの
                        </Typography>
                        <Typography variant={"subtitle1"} component="p" align="center" className={classes.guide_lead}>
                            {`以下の写真とアイテム情報をLINEでお送りください。\n必要な情報が揃っているほど、実物確認時との差が少ない査定額をご案内しやすくなります。`}
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={7}>
                                <div className={classes.checklist_card}>
                                    <Typography variant={"h3"} component="h3" className={classes.checklist_title}>
                                        写真で送るもの
                                    </Typography>
                                    {photoChecklist.map((item, index) => (
                                        <div className={classes.checklist_item} key={item.title}>
                                            <span className={classes.checklist_number}>{index + 1}</span>
                                            <div>
                                                <Typography variant={"subtitle1"} component="p" style={{fontWeight: 'bold'}}>
                                                    {item.title}
                                                </Typography>
                                                <Typography variant={"body2"} component="p" className={classes.checklist_note}>
                                                    {item.note}
                                                </Typography>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <div className={classes.checklist_card}>
                                    <Typography variant={"h3"} component="h3" className={classes.checklist_title}>
                                        テキストで送るもの
                                    </Typography>
                                    {textChecklist.map((item, index) => (
                                        <div className={classes.checklist_item} key={item}>
                                            <span className={classes.checklist_number}>{index + 1}</span>
                                            <Typography variant={"subtitle1"} component="p">
                                                {item}
                                            </Typography>
                                        </div>
                                    ))}
                                    <Typography variant={"body2"} component="p" className={classes.checklist_note}>
                                        商品状態は、汚れ・傷・使用感・付属品の有無など分かる範囲で問題ありません。
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>
                        <div className={classes.example_box}>
                            <Typography variant={"h3"} component="h3" className={classes.checklist_title}>
                                LINE送信例
                            </Typography>
                            <Typography variant={"body1"} component="p" className={classes.example_text}>
                                {`ブランド：COMME des GARCONS\nアイテム名：ジャケット\nサイズ：M\n商品状態：目立つ汚れなし。袖口に少し使用感あり。`}
                            </Typography>
                        </div>
                    </div>
                    <Typography variant={"h1"} component="h2" className={classes.sub_title} align="center">
                        査定方法
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <Typography variant={"h3"} className={classes.method_sub_title} component="h3" align="center">
                                1. 友達追加
                            </Typography>
                            <Typography variant={"p"} component="p" align="center" className={classes.text}>
                                LINEでEnclopediaを友達に追加
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <Typography variant={"h3"} className={classes.method_sub_title} component="h3" align="center">
                                2. 撮影
                            </Typography>
                            <Typography variant={"p"} component="p" align="center" className={classes.text}>
                                必要な写真を撮影
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <Typography variant={"h3"} className={classes.method_sub_title} component="h3" align="center">
                                3. 送信
                            </Typography>
                            <Typography variant={"p"} component="p" align="center" className={classes.text}>
                                撮影した写真とアイテム情報を送信
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <Typography variant={"h3"} className={classes.method_sub_title} component="h3" align="center">
                                4. 査定結果
                            </Typography>
                            <Typography variant={"p"} component="p" align="center" className={classes.text}>
                                査定結果を24時間以内にLINEメッセージからお知らせ
                            </Typography>
                        </Grid>
                    </Grid>
                    {/*査定方法のステップ*/}
                    <Typography variant={"h1"} component="h2" className={classes.sub_title} align="center">
                        撮影方法
                    </Typography>
                    {/*撮影方法のステップ*/}
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <Typography variant={"p"} component="p" align="center" className={classes.text}>
                                服の表を全体撮影
                            </Typography>
                            <div style={{textAlign: 'center', width:'100%'}}>
                                <img className={classes.shooting_method} src={buildImg('subscription/line_estimate3.jpg')} alt="服の表を全体撮影" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <Typography variant={"p"} component="p" align="center" className={classes.text}>
                                服の裏を全体撮影
                            </Typography>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.shooting_method} src={buildImg('subscription/line_estimate4.jpg')} alt="服の裏を全体撮影" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <Typography variant={"p"} component="p" align="center" className={classes.text}>
                                ブランドタグ・ロゴの撮影
                            </Typography>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.shooting_method} src={buildImg('subscription/line_estimate1.jpg')} alt="ブランドタグ・ロゴの撮影" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <Typography variant={"p"} component="p" align="center" className={classes.text}>
                                品質タグの撮影
                            </Typography>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.shooting_method} src={buildImg('subscription/ line_estimate2.jpg')} alt="品質タグの撮影" />
                            </div>
                        </Grid>
                    </Grid>
                    <Typography variant={"p"} component="p" align="center" className={classes.caution_text}>
                        明るい場所でピントを合わせブレのない撮影をしてください。傷や汚れがある場合は、その箇所が分かる写真もあわせてお送りください。
                    </Typography>
                    <Typography variant={"h1"} component="h2" className={classes.sub_title} align="center">
                        注意事項
                    </Typography>
                    {/*査定時の注意事項*/}
                    <Typography variant={"p"} component="p" align="center" className={classes.text}>
                        {`通常24時間以内,10時から20時の間の返信となります。\n
                        実際に拝見した際のアイテムの状態、在庫状況により査定金額が変動する場合がございます。
                        商品の状態に関して細かくご提示頂くことで実際に拝見した際の査定額が正確になります。\n
                        ブランドタグ、品質タグがついていないアイテムに関しては査定ができない場合がございますのでご了承下さい。
                        `}
                    </Typography>
                    <Grid container spacing={1} className={classes.line_url_container}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.line_url} src="https://qr-official.line.me/gs/M_240yzqkh_BW.png?oat_content=qr" alt="LINE公式アカウントQRコード" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant={"h3"} className={classes.method_sub_title} align="center" component="h3">
                                「QRコード」または「@240yzqkh」でID検索
                            </Typography>
                            <div style={{textAlign: 'center', marginTop: 8}}>
                                <Button variant="contained" component={"a"} href="https://line.me/R/ti/p/@240yzqkh" target="_blank" rel="noopener" className={classes.line_cta_button}>
                                    LINEで今すぐ査定する
                                </Button>
                            </div>
                            {/*<div style={{textAlign: 'center', marginTop: 16}}>
                                <Link component={RouterLink} to="/kaitori_form" style={{color: 'black'}} underline="always">フォームで無料査定</Link>
                                <span style={{margin: '0 8px'}}>|</span>
                                <Link component={RouterLink} to="/kaitori/takuhai" style={{color: 'black'}} underline="always">宅配買取の流れを見る</Link>
                            </div> */}
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    )   
}

export default LineEstimate
